import { Overview } from './pages/Overview'

export const App = () => {
  return (
    <div className="container d-flex justify-content-center align-items-center h-100">
      <Overview />
    </div>
  )
}
